import loadable from '@loadable/component'
import { nanoid } from 'nanoid'

export const delayModules: { [key: string]: (() => void) | undefined } = {}

export const createDelayImport = (
	importModule: () => Promise<any>,
	delay?: number,
	name?: string
) => {
	return loadable(() => delayLoad(() => importModule(), delay, name))
}
export const delayLoad = async (
	fn: () => Promise<any>,
	delay = 1000,
	name = nanoid()
) => {
	await new Promise(res => {
		delayModules[name] = () => res(null)
		setTimeout(() => {
			res(null)
		}, delay)
	}).finally(() => {
		delayModules[name] = undefined
	})
	return await fn()
}
